const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  ballIcon: {
    width: '20px',
    height: '20px',
    marginRight: '5px',
    color: theme.palette.primary.green,
  },
  label: {
    fontWeight: 700,
    color: theme.palette.primary.blackLight,
  },
});

export default styles;
